/**
 * @generated SignedSource<<fc3226725ba32f3f1f5f451bcc126f1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type advertisersQueueItemConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly entityId?: string;
      readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
    };
  }>;
  readonly " $fragmentType": "advertisersQueueItemConnection";
};
export type advertisersQueueItemConnection$key = {
  readonly " $data"?: advertisersQueueItemConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"advertisersQueueItemConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "advertisersQueueItemConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "contentItemRenderContent"
                }
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemConnection",
  "abstractKey": null
};

(node as any).hash = "43bfa67b6471615b8437ee834a854aec";

export default node;
